import {GlobalVariables} from "../GlobalVariables";
import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockCollapse {

    constructor() {
        this.collapses = document.querySelectorAll(".block-collapse .collapse, .block-text-collapse .collapse");
        this.build();
        GlobalVariables.resizeCallbacks.push(this);
    }

    build() {
        this.collapses.forEach(collapse => {
            const head = collapse.querySelector(".collapse-head");
            const body = collapse.querySelector(".collapse-body");
            body.dataset.height = body.clientHeight;
            body.style.height = 0;
            head.addEventListener("click", () => {
                let current = collapse;

                // Fermeture de toutes les autres lignes
                this.collapses.forEach(elem => {
                    if (elem !== current) {
                        elem.classList.remove("open");
                        elem.classList.add("inactive");
                        gsap.to(elem.querySelector(".collapse-body"), {
                            height: 0,
                            duration: 0.3,
                            onComplete: () => ScrollTrigger.refresh()
                        });
                    }
                });

                // Fermeture de la ligne courante si dejà ouverte
                if (collapse.classList.contains("open")) {
                    collapse.classList.remove("open");
                    gsap.to(body, {
                        height: 0,
                        duration: 0.3,
                        onComplete: () => ScrollTrigger.refresh()
                    });
                }

                // Ouverture de la ligne courante
                else {
                    collapse.classList.add("open");
                    collapse.classList.remove("inactive");
                    gsap.to(body, {
                        height: body.dataset.height,
                        duration: 0.3,
                        onComplete: () => ScrollTrigger.refresh()
                    });
                }

                // Vérification si des lignes sont actives
                let isActive = false;
                this.collapses.forEach(elem => {
                    if (elem.classList.contains("open")) {
                        isActive = true;
                    }
                });

                // Si aucune ligne active on rénitialise l'ensemble des lignes
                if (!isActive) {
                    this.collapses.forEach(elem => {
                        elem.classList.remove("inactive");
                    });
                }
            });
        });
    }

    resize() {
        this.collapses.forEach(collapse => {
            const body = collapse.querySelector(".collapse-body");
            body.style.height = "auto";
            body.dataset.height = body.clientHeight;
            if (!collapse.classList.contains("open")) {
                body.style.height = 0;
            }
        });
    }
}
